<template>
  <b-button
    :variant="variant"
    :size="size"
    :class="classes"
    @click="handleClick"
  >
    {{ label }}
  </b-button>
</template>
<script>
import {
  BButton,
} from 'bootstrap-vue'
import axios from '@axios'

export default {
  components: {
    BButton,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    href: {
      type: String,
      required: true,
    },
    xparam1: {
      type: [Object, String, null],
      required: false,
    },
    xparam2: {
      type: [Object, String, null],
      required: false,
    },
    xparam3: {
      type: [Object, String, null],
      required: false,
    },
    xparam4: {
      type: [Object, String, null],
      required: false,
    },
    xparam5: {
      type: [Object, String, null],
      required: false,
    },
    xparam6: {
      type: [Object, String, null],
      required: false,
    },
    q: {
      type: [Object, String, null],
      required: false,
    },
    format: {
      type: String,
      required: true,
    },
    variant: {
      type: String,
      required: false,
      default: null,
    },
    size: {
      type: String,
      required: false,
      default: null,
    },
    classes: {
      type: String,
      required: false,
      default: null,
    },
  },
  setup(props) {
    const handleClick = () => {
      // eslint-disable-next-line prefer-destructuring
      let href = props.href
      // eslint-disable-next-line prefer-destructuring
      const xparam1 = props.xparam1
      // eslint-disable-next-line prefer-destructuring
      const xparam2 = props.xparam2
      // eslint-disable-next-line prefer-destructuring
      const xparam3 = props.xparam3
      // eslint-disable-next-line prefer-destructuring
      const xparam4 = props.xparam4
      // eslint-disable-next-line prefer-destructuring
      const xparam5 = props.xparam5
      // eslint-disable-next-line prefer-destructuring
      const xparam6 = props.xparam6
      // eslint-disable-next-line prefer-destructuring
      const q = props.q
      const params = new URLSearchParams(JSON.parse(JSON.stringify({
        xparam1,
        xparam2,
        xparam3,
        xparam4,
        xparam5,
        xparam6,
        q,
      }))).toString()
      if (href.indexOf('?') > -1) {
        // eslint-disable-next-line no-param-reassign
        href += `&${params}`
      } else {
        // eslint-disable-next-line no-param-reassign
        href += `?${params}`
      }
      axios({
        url: href,
        method: 'GET',
        responseType: 'blob',
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${Date.now()}.${props.format}`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    }

    return {
      handleClick,
    }
  },
}
</script>
